import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppBaseComponent } from '../../app-base.component';
import { AnswerGroupGridItemDto, AnswerGroupService, AnswerGroupState } from '@proxy/answer-groups';

@Component({
    selector: 'app-answer-groups-dropdown',
    templateUrl: './answer-groups-dropdown.component.html',
    standalone: false
})
export class AnswerGroupsDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() answerGroupId: number;

  @Output() changeAnswerGroup = new EventEmitter<number>();

  answerGroups: AnswerGroupGridItemDto[];
  answerGroup: AnswerGroupGridItemDto;

  constructor(
    injector: Injector,
    private readonly _answerGroupService: AnswerGroupService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getAnswerGroups();
  }

  async getAnswerGroups(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._answerGroupService.getAllAnswerGroupsByInput({
        maxResultCount: undefined,
        skipCount: undefined,
        state: AnswerGroupState.Active
      }));

      this.answerGroups = result.items;
      this.answerGroup = this.answerGroups.find(x => x.id === this.answerGroupId);

    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeAnswerGroup.emit(this.answerGroup?.id);
  }
}
